import {
    Collapse,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    makeStyles,
    Menu,
    MenuItem,
    TextField,
    Typography,
} from "@material-ui/core"
import { Add, AddAPhoto, ExpandMoreOutlined, MoreVert } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { memo, useCallback, useRef, useState } from "react"
import { redimensionarPara300x300 } from "../../../functions/imagens"
import { inativarProduto } from "../../../services/cardapio"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCardapioContext } from "./CardapioContext"
import DisponibilidadeSwitch from "./DisponibilidadeSwitch"
import ItemPasso from "./ItemPasso"

const ITEM_HEIGHT = 48

const useStyles = makeStyles(() => ({
    container: {
        width: "100%",
    },
    containerImg: {
        margin: "auto",
        maxWidth: "80px",
        height: "80px",
        backgroundColor: "#eee",
        border: "2px dashed #ccc",
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: "10px",
    },
    addAPhoto: {
        margin: "auto",
        display: "block",
        width: "40%",
        height: "40%",
        color: "rgba(0,0,0,0.5)",
    },
    input: {
        display: "none",
    },
    collapse: {
        width: "100%",
    },
}))

const ItemProduto = memo(function ItemProduto({ conteudo, categoria }) {
    const {
        setOpenproduto,
        setModalProduto,
        setCadastrar,
        setModalPasso,
        setOpenPassoDeMontagem,
        setProdutoAtual,
        handleDuplicarProduto,
        handleExcluirProduto,
        handleIdsEditar,
        handleCadastrarImagem,
        buscarFT,
        setCategorias,
    } = useCardapioContext()

    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const autorizacao = localStorage.getItem("chaveSistema")

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [expanded, setExpanded] = useState(false)
    const handleExpandClick = useCallback(() => {
        setExpanded(!expanded)
    }, [expanded])

    const [anchorEl, setAnchorEl] = useState(null)

    const openMoreProduto = Boolean(anchorEl)
    const handleClickMoreProduto = useCallback(
        event => {
            setCadastrar(true)
            setAnchorEl(event.currentTarget)
        },
        [setCadastrar]
    )

    const handleCloseMoreProduto = useCallback(() => {
        setAnchorEl(null)
    }, [])

    const fileInputRef = useRef(null)
    const handleDivClick = useCallback(() => {
        fileInputRef.current.click()
    }, [])

    const handleFileChange = useCallback(
        async event => {
            const file = event.target.files[0]
            if (!file) return

            try {
                const file300 = await redimensionarPara300x300(file)
                const nomeArquivo = file.name
                const idProduto = conteudo.id
                const idOpcao = null
                const idPasso = null

                handleCadastrarImagem(nomeArquivo, idProduto, idPasso, idOpcao, file300)
            } catch (error) {
                alertStart(`${error}`, "error")
            }
        },
        [conteudo.id, handleCadastrarImagem, alertStart]
    )

    const handleClickOpenProduto = useCallback(() => {
        setOpenproduto(true)
    }, [setOpenproduto])

    const handleChangeOrdemExib = useCallback(
        e => {
            handleIdsEditar(conteudo.id)
            conteudo.ordemExib = e.target.value
        },
        [conteudo, handleIdsEditar]
    )

    const handleChangeNome = useCallback(
        e => {
            handleIdsEditar(conteudo.id)
            conteudo.nome = e.target.value
        },
        [conteudo, handleIdsEditar]
    )

    const handleChangeDescricao = useCallback(
        e => {
            handleIdsEditar(conteudo.id)
            conteudo.descricao = e.target.value
        },
        [conteudo, handleIdsEditar]
    )

    const handleChangeValor = useCallback(
        e => {
            handleIdsEditar(conteudo.id)
            const valorFormatado = e.target.value.replace(",", ".").toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            conteudo.valor = parseFloat(valorFormatado)
        },
        [conteudo, handleIdsEditar]
    )

    const handleChangeDisponibilidadeProduto = useCallback(
        async () => {
            setLoading(true)
            const response = await inativarProduto(conteudo.id, conteudo.ativo, autorizacao)
            if (response.retornoErro) {
                console.error(response)
                alertStart(response.mensagem, "error")
            } else {
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id !== categoria.id
                            ? cat
                            : {
                                  ...cat,
                                  produtos: cat.produtos.map(prod =>
                                      prod.id !== conteudo.id
                                          ? prod
                                          : { ...prod, ativo: !prod.ativo }
                                  ),
                              }
                    )
                )
                alertStart("Disponibilidade do produto alterada com sucesso", "success")
            }
            setLoading(false)
        },
        [conteudo, categoria, autorizacao, setLoading, alertStart, setCategorias]
    )

    const handleClickPassoDeMontagem = useCallback(() => {
        setOpenPassoDeMontagem(true)
    }, [setOpenPassoDeMontagem])

    const classes = useStyles()

    // const handleDragStart = index => {
    //     setDraggingProduto(index)
    // }
    // const handleDragEnd = () => {
    //     setDraggingProduto(null)
    // }

    // const [draggingOpcoes, setDraggingOpcoes] = useState(null)
    // const handleDragOver = index => {
    //     if (draggingOpcoes === null) return
    //     if (draggingOpcoes === index) return
    //     const itens = [...passos]
    //     const [removido] = itens.splice(draggingOpcoes, 1)
    //     itens.splice(index, 0, removido)
    //     itens.forEach((item, idx) => {
    //         if (item) {
    //             item.ordemExib = idx
    //         }
    //     })
    //     setDraggingOpcoes(index)
    //     setPassos(itens)
    // }

    return (
        <div
            // draggable={!expanded}
            // onDragStart={e => handleDragStart(index)}
            // onDragEnd={handleDragEnd}
            className={classes.container}
        >
            <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                <Grid
                    className={classes.containerImg}
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    onClick={handleDivClick}
                    xs={12}
                    sm={6}
                    md={1}
                >
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        {conteudo.urlImagem ? (
                            <img
                                id={`imagemProduto${conteudo.id}`}
                                loading="lazy"
                                style={{
                                    borderRadius: "10px",
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }}
                                src={conteudo.urlImagem}
                                alt="Imagem"
                            />
                        ) : (
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <AddAPhoto className={classes.addAPhoto} />
                            </Grid>
                        )}
                    </Grid>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        className={classes.input}
                        accept="image/*"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={1} container id="texto">
                    <TextField
                        fullWidth
                        type="number"
                        variant="outlined"
                        label="Ord. Exibição"
                        id={`ordemExibProduto${conteudo.id}`}
                        InputLabelProps={{ shrink: true }}
                        defaultValue={conteudo.ordemExib}
                        onChange={handleChangeOrdemExib}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2} container id="texto">
                    <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="Produto"
                        id={`nomeProduto${conteudo.id}`}
                        InputLabelProps={{ shrink: true }}
                        defaultValue={conteudo.nome}
                        onChange={handleChangeNome}
                    />
                </Grid>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    item
                    xs={12}
                    sm={12}
                    md={2}
                >
                    <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="Descrição"
                        id={`descricaoProduto${conteudo.id}`}
                        InputLabelProps={{ shrink: true }}
                        defaultValue={conteudo.descricao}
                        onChange={handleChangeDescricao}
                    />
                </Grid>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    item
                    xs={12}
                    sm={12}
                    md={2}
                >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        label="Preço"
                        id={`valorProduto${conteudo.id}`}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                        inputProps={{ style: { textAlign: "right" } }}
                        defaultValue={conteudo.valor}
                        onChange={handleChangeValor}
                    />
                </Grid>
                <Grid item container xs={8} sm={8} md={2} justifyContent="center">
                    <DisponibilidadeSwitch
                        produto={true}
                        disponivel={conteudo.ativo}
                        handleChangeDisponibilidadeProduto={handleChangeDisponibilidadeProduto}
                    />
                </Grid>
                <Grid
                    item
                    container
                    xs={4}
                    sm={4}
                    md={1}
                    alignItems="center"
                    justifyContent="center"
                >
                    <IconButton onClick={handleClickMoreProduto}>
                        <MoreVert fontSize="medium" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMoreProduto}
                        onClose={handleCloseMoreProduto}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: "20ch",
                            },
                        }}
                    >
                        <MenuItem
                            onClick={async () => {
                                handleClickOpenProduto()
                                setModalProduto(conteudo)
                                setCadastrar(false)
                                await buscarFT("produto", conteudo.id, null)
                            }}
                        >
                            Editar Produto
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleDuplicarProduto(conteudo.id, categoria.id)
                            }}
                        >
                            Duplicar Produto
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleExcluirProduto(conteudo.id, categoria.id)
                            }}
                        >
                            Excluir Produto
                        </MenuItem>
                    </Menu>
                    <IconButton onClick={handleExpandClick}>
                        <ExpandMoreOutlined />
                    </IconButton>
                </Grid>

                {expanded && (
                    <Collapse
                        className={classes.collapse}
                        in={expanded}
                        timeout="auto"
                        unmountOnExit
                    >
                        <Divider />
                        <Grid container direction="row" spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                                <Grid fullWidth>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        container
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Typography>Passos de montagem</Typography>
                                        <IconButton
                                            onClick={() => {
                                                setCadastrar(true)
                                                setModalPasso(null)
                                                handleClickPassoDeMontagem()
                                                setProdutoAtual(conteudo)
                                            }}
                                        >
                                            <Add fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                    <Grid>
                                        <List>
                                            {conteudo?.opcoes.map(opcao => (
                                                <ListItem key={opcao.id}>
                                                    <ItemPasso opcao={opcao} conteudo={conteudo} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Collapse>
                )}
            </Grid>
        </div>
    )
})

export default ItemProduto
